// extracted by mini-css-extract-plugin
export var ad = "Ad-module__ad___MKXdp";
export var advertisement = "Ad-module__advertisement___QG5VP";
export var button = "Ad-module__button___rF9Nl";